export { default as NdaSolidIcon } from './NdaSolidIcon';
